import React, {FC} from 'react';
import styled from "styled-components";
import {Bottom, ContentMedium, CrossMedium, LabMedium, LogoMedium, RuleMedium} from "../Common/CommonStyled";

import logo_color from '../../../assets/images/print_logo_color.png'
import lab from '../../../assets/images/lab.svg'
import cross from '../../../assets/images/ticket_white_cross.svg'
import {ArtifactItemType, PrintRoomType} from "../../../types/Types";
import {baseURL} from "../../../api/api";

const QRCode = require('qrcode.react');

const TicketLayout = styled.div`
    background-color: #F2F3F7;
    width: 396px;
    height: 560px;
    position: relative;
    margin: 0 auto;
    &:nth-child(2n-1) {
      border-right: 2px solid black;
    }
    &:nth-child(4n-3) {
      border-bottom: 1px solid black;
    }
    &:nth-child(4n-2) {
      border-bottom: 1px solid black;
    }
`
const Id = styled.div({
    color: '#7764F5',
    fontSize: 20,
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
    marginBottom: 20,
    letterSpacing:'0.1em',
})
const QrContainer = styled.div`
      padding: 20px;
      width: 290px;
      height: 290px;
      background-color: white;
      margin-bottom: 15px;
    `
const Name = styled.div({
    textAlign: 'center',
    color:'#7764F5',
    fontSize: 28,
    fontWeight: 600,
    marginBottom: 20
})

const MediumQr:FC<{item: PrintRoomType | ArtifactItemType, section: string}> = React.memo(({item, section}) => {
    return (
        <TicketLayout>
            <ContentMedium>
                <Name>{item.name}</Name>
                <QrContainer>
                    <QRCode
                        value={baseURL + (section === 'rooms' ? `rooms/${item.id}` : `artifacts/${item.id}`)}
                        size={250}
                    />
                </QrContainer>
                <RuleMedium>
                    Отсканируйте QR-код
                </RuleMedium>
                {
                    section === 'rooms' &&
                    <Id>ID: 2_{item.id}</Id>
                }
                {
                    section === 'artifacts' &&
                    <Id>ID: 1_{item.id}</Id>
                }
                <Bottom>
                    <LogoMedium src={logo_color} alt='logo' />
                    <CrossMedium src={cross} alt='cross' />
                    <LabMedium src={lab} alt='lab' />
                </Bottom>
            </ContentMedium>
        </TicketLayout>
    );
})

export default MediumQr;
